module.exports = __webpack_public_path__ + "static/media/css3.38445e8d.svg";